import React from 'react'

import { useTranslation } from '../../../app/_providers/TranslationProvider.client'
import {
  NavAccordion as INavAccordion,
  NavAccordionSection as INavAccordionSection,
  NavListItem as INavListItem,
} from '../../../types/graphql/site-fixtures'
import { Body, Header, Section } from '../NavAccordion/styles'
import { NavListItem } from '../NavListItem'
import { renderNavSection } from '../renderNavSection'

import { StyledNavSubMenuDialog, TriggerCaret, TriggerRow } from './styles'

export const NavOverlayAccordion: React.FC<INavAccordion & { closeModal: () => void }> = ({
  closeModal,
  sections,
}) => {
  return (
    <Body role='list'>
      {sections.map(section => {
        return <NavOverlayAccordionSection closeModal={closeModal} key={section.id} {...section} />
      })}
    </Body>
  )
}

const NavOverlayAccordionSection: React.FC<
  INavAccordionSection & {
    closeModal: () => void
  }
> = ({ body: bodyProp, closeModal, header }) => {
  const {
    magnolia: { general: generalStrings, navigation: navigationStrings },
  } = useTranslation()

  const body =
    bodyProp?.__typename === 'NavListSection' ||
    bodyProp?.__typename === 'NavTileSection' ||
    bodyProp?.__typename === 'RawHtmlSection'
      ? bodyProp
      : undefined

  const headerItem: INavListItem = {
    ...header,
    // With a body, the row opens the sub menu rather than navigating; without one it stays a link.
    href: body ? null : header.href,
    isBold: true,
    isHeading: false,
  }

  const sharedSectionProps = {
    isFooterVariant: false,
    isOpen: false,
    isOpenDisabled: !body,
  }

  if (!body) {
    return (
      <Section {...sharedSectionProps} role='listitem'>
        <Header isOpen={false}>
          <NavListItem {...headerItem} textRole='none' />
        </Header>
      </Section>
    )
  }

  return (
    <Section {...sharedSectionProps} role='listitem'>
      <StyledNavSubMenuDialog
        backLabel={generalStrings.back}
        closeLabel={navigationStrings.closeButtonLabel}
        onCloseNav={closeModal}
        title={header.text}
        trigger={
          <TriggerRow
            type='button'
            aria-label={navigationStrings.openSubMenuAriaLabel.replace('{{menuName}}', header.text)}
          >
            <Header isOpen={false}>
              <NavListItem {...headerItem} textRole='none' />
            </Header>
            <TriggerCaret aria-hidden='true' />
          </TriggerRow>
        }
      >
        {renderNavSection(body)}
      </StyledNavSubMenuDialog>
    </Section>
  )
}
